import React from 'react'
import { Box} from '@mui/material';
import { Container, TextField } from '@mui/material';
// import  from '@mui/material';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
// import LoggedInNav from '../../../../../Layouts/LoggedInNav/LoggedInNav';
import InputAdornment from '@mui/material/InputAdornment';


export default function AddLoanPage() {


    
  return (
    <Box>
        <h4>Add New Loan</h4>
        {/* <Box id="topInfo" sx={{backgroundColor:'rgb(80,99,129)'}}> */}
            <Grid container spacing={1} sx={{backgroundColor:'rgb(80,99,129)'}}>
                <Grid item xs={6} style={{borderRight:'2px solid grey'}}>
                    <h3 style={{color:'white'}}>Loan Info</h3>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                        {/* , width: '25ch' */}
                            <FormControl fullwidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="streetOne" sx={{color:'white'}}>Loan #</InputLabel>
                                <Input
                                    id="streetOne"
                                    type={'text'}
                                    sx={{color:'white'}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullwidth={true} sx={{ m: 1,color:'white' }} variant="standard">
                                <InputLabel htmlFor="loanNumber" sx={{color:'white'}}>Borrower</InputLabel>
                                <Input
                                    id="loanNumber"
                                    type={'text'}
                                    sx={{color:'white'}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullwidth={true} sx={{ m: 1 }} variant="standard">
                                <InputLabel htmlFor="generalContractor" sx={{color:'white'}}>General Contractor</InputLabel>
                                <Input
                                    id="generalContractor"
                                    type={'text'}
                                    sx={{color:'white'}}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullwidth={true} sx={{ m: 1}} variant="standard">
                                <InputLabel htmlFor="phoneNumber" sx={{color:'white'}}>Phone</InputLabel>
                                <Input
                                    id="phoneNumber"
                                    type={'text'}
                                    sx={{color:'white'}}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={6}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <h3 style={{color:'white', textAlign:'center'}}>Property Address</h3>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                            {/* , width: '35ch', */}
                                <FormControl sx={{ m: 1,float:'left', color:'white' }} fullwidth={true} variant="standard">
                                    <InputLabel htmlFor="streetOne" sx={{color:'white'}}>Street</InputLabel>
                                    <Input
                                        id="streetOne"
                                        type={'text'}
                                        sx={{color:'white'}}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                            {/* width: '25ch', */}
                                    <FormControl fullwidth={true} sx={{ m: 1, float:'left', color:'white' }} variant="standard">
                                        <InputLabel htmlFor="streetTwo" sx={{color:'white'}}>Street 2</InputLabel>
                                        <Input
                                            id="streetTwo"
                                            type={'text'}
                                            sx={{color:'white'}}
                                        />
                                    </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                            {/* width: '25ch', */}
                                <FormControl fullwidth={true} sx={{ m: 1,float:'left',colo:'white' }} variant="standard">
                                    <InputLabel htmlFor="city" sx={{color:'white'}}>City</InputLabel>
                                    <Input
                                        id="city"
                                        type={'text'}
                                        sx={{color:'white'}}
                                    />
                                </FormControl>
                                <FormControl fullwidth={true} sx={{ m: 1,float:'left' }} variant="standard">
                                    <InputLabel htmlFor="state" sx={{color:'white'}}>State</InputLabel>
                                    <Input
                                        id="state"
                                        type={'text'}
                                        sx={{color:'white'}}
                                    />
                                </FormControl>
                                <FormControl fullwidth={true} sx={{ m: 1,float:'left' }} variant="standard">
                                    <InputLabel htmlFor="zipcode" sx={{color:'white'}}>Zip Code</InputLabel>
                                    <Input
                                        id="zipcode"
                                        type={'text'}
                                        sx={{color:'white'}}
                                    />
                                </FormControl>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        {/* </Box> */}
        <Box id="costsSection" style={{border:'2px solid black', backgroundColor:'rgb(80,99,129)'}}>
                <Grid container spacing={2}>
                    {/* Soft Cost Section */}
                    <Grid item xs={6} sx={{mt:2}}>
                        <Grid container item spacing={2}>
                            <Grid item xs={12}>
                                <h3 style={{color:'white', textAlign:'center'}}>Soft Costs</h3>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField type='text' label='Item'></TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                label="Budget"
                                id="outlined-start-adornment"
                                fullWidth={true}
                                // sx={{ m: 1, width: '25ch' }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Container>
                                    <Button variant='contained' sx={{mt:2}}>Add Soft Cost</Button>
                                </Container>
                            </Grid>
                            <Grid item xs={12}>
                                <Container sx={{mt:2, backgroundColor:'white'}}>
                                    <h6> Added Soft Costs</h6>
                                </Container>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={6} sx={{mt:2}}>
                        <Grid container item spacing={1}>
                            <Grid item xs={12}>
                                <Container sx={{mb:5}}>
                                    <h3 style={{color:'white', textAlign:'center'}}>Hard Costs</h3>
                                </Container>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField type='text' label='Item'></TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                label="Budget"
                                id="outlined-start-adornment"
                                // sx={{ m: 1, width: '25ch' }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Container>
                                    <Button variant='contained' sx={{mt:2}}>Add Hard Cost</Button>
                                </Container>
                            </Grid>
                            <Grid item xs={12}>
                                <Container sx={{mt:2, backgroundColor:'white'}}>
                                    <h6> Added Hard Costs</h6>
                                </Container>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
        </Box>

    </Box>
  )
}
